"use client";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Box,
    Typography,
    Stack,
    TextField,
    Button,
    CircularProgress
} from "@mui/material";
import "../auth.css";
import IconButton from "@mui/material/IconButton";
import { postMethod, getMethod } from "../../../services/apiService";
import { SHA512 } from 'crypto-js';
import { LogoutModal } from '../../partials/LogoutModal';

const LoginSSO = () => {
    const navigate = useNavigate();

    //If the user is already logged in then redirect to the /Network page
    useEffect(() => {
        const sess_user = localStorage.getItem("sess_user");
        if (sess_user !== null && sess_user !== undefined && sess_user != "") {
            navigate('/customer/overview');
        }
    }, [])

    // const router = useRouter();
    const [isLoading, setIsLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState("");
    const [openLogoutModal, setOpenLogoutModal] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('mo_fb_jwt_token');

    useEffect(() => {
        const login = async () => {
            // e.preventDefault();
            let payload = {
                "mo_fb_jwt_token": token
            }

            const resp = await postMethod("sso/login", payload);
            if (resp?.data?.code === 200) {
                setIsLoading(false);
                if (resp?.data?.result?.[0]?.userProfile?.priority > 101) {


                    const resp = await getMethod("central/user/auth/logout");
                    setErrorMsg("You do not have permission to access this website!")

                    // setOpenLogoutModal(true);
                } else {
                    document.cookie = `JSESSIONID=${resp?.data?.result[0].JSESSIONID}`;
                    localStorage.setItem("sess_user", JSON.stringify(resp?.data?.result[0]));
                    navigate("/customer/overview");
                }
            } else {
                setIsLoading(false);
                setErrorMsg(resp?.data?.message);
            }
        };
        login();
    }, []);

    return (
        <>
            <Box className="auth-banner">
                <Box className="login-box">
                    <Box
                        sx={{
                            textAlign: "center",
                        }}
                    >
                        <img
                            src="/logo.svg"
                            alt="Logo"
                            style={{ cursor: "pointer", marginBottom: "24px" }}
                        />
                        <Typography
                            sx={{
                                fontFamily: "sans-serif",
                                fontWeight: 500,
                                fontSize: "24px",
                                mb: "20px",
                            }}
                        >
                            Login
                        </Typography>
                        <br />
                        <Typography
                            sx={{
                                fontFamily: "sans-serif",
                                fontWeight: 500,
                                fontSize: "18px",
                                mb: "20px",
                            }}
                        >
                            Authenticating... Ensuring a secure login.
                        </Typography>


                        <Stack sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "100%",
                        }}>
                            {/* Error message display */}
                            <Typography
                                sx={{
                                    mb: "24px",
                                    fontSize: "14px",
                                    textAlign: "center",
                                    color: "#FB462E",
                                }}
                            >
                                {errorMsg}
                            </Typography>

                            {isLoading &&
                                <CircularProgress color={"info"} size={44} />
                            }

                        </Stack>
                    </Box>
                </Box>

            </Box>

            <LogoutModal setOpenLogoutModal={setOpenLogoutModal} openLogoutModal={openLogoutModal} />

        </>
    );
}
export default LoginSSO;